import React from 'react'
import { Link } from 'react-router-dom'

const CancelBookings = () => {
    return (
        <div className='light-shadow rounded-[1rem] py-4 px-4'>
            <div className='flex items-center justify-between text-dark text-sm'>
                <p>Cancel Bookings</p>
                <Link to='#' className='text-primary underline'>
                    View All
                </Link>
            </div>
            <div>
                <table className='text-[13px] w-full '>
                    <thead>
                        <tr>
                            <td>Name</td>
                            <td>Date</td>
                            <td>Screens</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            [...Array(6).keys()].map(item => (
                                <tr key={item}>
                                    <td>
                                        <b>Alex</b>
                                    </td>
                                    <td>
                                        13/10/2023
                                    </td>
                                    <td>
                                        12
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default CancelBookings